const initialState = {
    responseDiscountsList: [],
    responseDiscount: {},
    responseCategoriesNameList: [],
    responseCategoryName: [],
    responseDiscountsHistoryList: [],
    responseDiscountHistory: {},

    responseHashExportHistoryCoupons: [],
    responseUpdateReportHistoryCoupons: [],
    responseCheckReportHistoryCoupons: [],
    errorHashExportHistoryCoupons: false,
    errorCheckReportHistoryCoupons: false,
    errorUpdateReportHistoryCoupons: false,

    responseHashExportDiscounts: [],
    responseCheckReportDiscounts: [],
    responseUpdateReportDiscounts: [],
    errorHashExportDiscounts: false,
    errorCheckReportDiscounts: false,
    errorUpdateReportDiscounts: false,
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "DISCOUNTS_RESPONSE_LIST":
            if (action.value.detail !== undefined)
                newState.responseDiscountsList = []
            else
                newState.responseDiscountsList = action.value;

            newState.responseDiscount = {}
            break;

        case "DISCOUNT_RESPONSE":
            newState.responseDiscount = action.value;
            break;

        case "CATEGORIESNAME_RESPONSE_LIST":
            if (action.value.detail !== undefined)
                newState.responseCategoriesNameList = []
            else
                newState.responseCategoriesNameList = action.value;
            break;

        case "CATEGORIESNAME_RESPONSE":
            newState.responseCategoryName = action.value;
            break;

        case "DISCOUNTS_HISTORY_RESPONSE_LIST":
            if (action.value.detail !== undefined)
                newState.responseDiscountsHistoryList = []
            else
                newState.responseDiscountsHistoryList = action.value;

            newState.responseDiscountHistory = {}
            break;

        case "DISCOUNT_HISTORY_RESPONSE":
            newState.responseDiscountHistory = action.value;
            break;
        case 'HASH_EXPORT_DISCOUNTS_HISTORY_RESPONSE':
            newState.responseHashExportHistoryCoupons = action.value;
            if (action.value.detail !== undefined) {
                newState.errorHashExportHistoryCoupons = true;
            } else {
                newState.errorHashExportHistoryCoupons = false;
            }
            break;
        case 'REPORT_EXPORT_DISCOUNTS_HISTORY_RESPONSE':
            newState.responseCheckReportHistoryCoupons = action.value;
            if (action.value.detail !== undefined) {
                newState.errorCheckReportHistoryCoupons = true;
            } else {
                newState.errorCheckReportHistoryCoupons = false;
            }
            break;
        case 'UPDATE_EXPORT_DISCOUNTS_HISTORY_RESPONSE':
            newState.responseUpdateReportHistoryCoupons = action.value;
            if (action.value.detail !== undefined) {
                newState.errorUpdateReportHistoryCoupons = true;
            } else {
                newState.errorUpdateReportHistoryCoupons = false;
            }
            break;

        case 'HASH_EXPORT_DISCOUNTS_RESPONSE':
            newState.responseHashExportDiscounts = action.value;
            if (action.value.status !== "OK") {
                newState.errorHashExportDiscounts = true;
            } else {
                newState.errorHashExportDiscounts = false;
            }
            break;
        case 'REPORT_EXPORT_DISCOUNTS_RESPONSE':
            newState.responseCheckReportDiscounts = action.value;
            if (action.value.status !== "OK") {
                newState.errorCheckReportDiscounts = true;
            } else {
                newState.errorCheckReportDiscounts = false;
            }
            break;
        case 'UPDATE_EXPORT_DISCOUNTS_RESPONSE':
            newState.responseUpdateReportDiscounts = action.value;
            if (action.value.status !== "OK") {
                newState.errorUpdateReportDiscounts = true;
            } else {
                newState.errorUpdateReportDiscounts = false;
            }
            break;
        default:
            return newState;

    }

    return newState;
};

export default reducer;